"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCitiesData = getCitiesData;
exports.getCityList = getCityList;
exports.getCountryList = getCountryList;
exports.getNationalityBlobList = getNationalityBlobList;
exports.getNationalityList = getNationalityList;
exports.getStateList = getStateList;
exports.readEmiratesId = readEmiratesId;
var _genericFetch = _interopRequireWildcard(require("../../../../common/api/genericFetch"));
var _ApiConst = require("../../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../../common/api/api';

function readEmiratesId(base64, tokenData) {
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.READ_OCR_API}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    data: base64
  };
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, apiPostData: { data: base64 }, requestType: API_PARAMS.POST });
}
function getNationalityList(tokenData) {
  const apiEndPoint = `${_ApiConst.ELASTIC_BASE_URL_V2}${_ApiConst.GET_NATIONALITY_LIST}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getNationalityBlobList(tokenData) {
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  const apiEndPoint = `${_ApiConst.BLOB_DATA_BASE_URL}${_ApiConst.GET_BLOB_NATIONALITY_LIST}`;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCountryList(tokenData) {
  const apiEndPoint = `${_ApiConst.ELASTIC_BASE_URL_V2}${_ApiConst.GET_COUNTRY_LIST}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getStateList(queryParam, tokenData) {
  const apiEndPoint = `${_ApiConst.ELASTIC_BASE_URL_V2}${_ApiConst.GET_STATE_LIST}${queryParam.country}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getCityList(queryParam, tokenData) {
  let apiEndPoint = `${_ApiConst.ELASTIC_BASE_URL_V2}${_ApiConst.GET_CITY_LIST}countryId=${queryParam.country}`;
  if (queryParam.state) {
    apiEndPoint = apiEndPoint + `&stateCode=${queryParam.state}`;
  }
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function getCitiesData() {
  const options = {};
  options.method = _ApiConst.API_PARAMS.GET;
  const apiEndPoint = `${_ApiConst.BLOB_DATA_BASE_URL}${_ApiConst.CITY_PICKER_MENU_DATA}`;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}